import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all centers */
export const getAllCenters = async (search = '', status = '', categoryId = '', params = {}) => {
    try {
        const queryParams = new URLSearchParams();
        if (search) queryParams.append('search', search);
        if (status) queryParams.append('status', status);
        if (categoryId) queryParams.append('categoryId', categoryId);
        if (params.page) queryParams.append('page', params.page);
        if (params.limit && params.limit !== 10) queryParams.append('limit', params.limit);

        const response = await axios.get(`${apiUrlOne}/centers/get-all-centers-admin?${queryParams.toString()}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching centers:", error);
        throw error;
    }
};

/* Fetch a single center by ID */
export const getCenterById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/centers/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching center with ID ${id}:`, error);
        throw error;
    }
};

/* Create a new center */
export const createCenter = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/centers/create-center-admin`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating center:", error);
        throw error;
    }
};

/* Update a center */
export const updateCenter = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/centers/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating center with ID ${id}:`, error);
        throw error;
    }
};

/* Delete a center */
export const deleteCenter = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/centers/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting center with ID ${id}:`, error);
        throw error;
    }
};

/* Fetch all center categories */
export const getCenterCategories = async (search = '') => {
    try {
        const queryParams = new URLSearchParams();
        if (search) queryParams.append('search', search);

        const response = await axios.get(`${apiUrlOne}/centers-categories${search ? `?${queryParams.toString()}` : ''}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching center categories:", error);
        throw error;
    }
};

/* Create a new center category */
export const createCenterCategory = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/centers-categories`, data);
        return response.data;
    } catch (error) {
        console.error("Error creating center category:", error);
        throw error;
    }
};

/* Update a center category */
export const updateCenterCategory = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/centers-categories/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(`Error updating center category with ID ${id}:`, error);
        throw error;
    }
};

/* Delete a center category */
export const deleteCenterCategory = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/centers-categories/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting center category with ID ${id}:`, error);
        throw error;
    }
};

/* Delete a center image */
export const deleteCenterImage = async (imageId) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/centers/image/${imageId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting center image with ID ${imageId}:`, error);
        throw error;
    }
};
